import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import FloatingBackground from './FloatingBackground';

function App() {
  const [noPosition, setNoPosition] = useState(null);
  const [yesClicked, setYesClicked] = useState(false);
  const [transitionOut, setTransitionOut] = useState(false);

  const handleNoClick = () => {
    const buttonWidth = 150;
    const buttonHeight = 60;
    const randomX = Math.random() * (window.innerWidth - buttonWidth);
    const randomY = Math.random() * (window.innerHeight - buttonHeight);
    setNoPosition({ x: randomX, y: randomY });
  };

  const handleYesClick = () => {
    setTransitionOut(true);
    setTimeout(() => {
      setYesClicked(true);
    }, 500);
  };

  if (yesClicked) {
    return (
      <div className="App">
        <FloatingBackground />
        <div className="celebration fade-in">
          <h1>Yay!</h1>
          <p>My Darling,</p>
          <p>In a hundred years, I could not imagine ever finding someone so deserving of all the joys and love in life as you are.</p>
          <p>In me you will always have a trusted, listening lover, a co-conspirator, a personal heater, a snack, and most of all a friend.</p>
          <p>You are my sun, my moon and angel on earth.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <FloatingBackground />
      <div className={`valentine-card ${transitionOut ? 'fade-out' : ''}`}>
        <h1 className="question">Renew Boyfriend Subscription?</h1>
        <div className="buttons-container">
          <button className="yes-btn" onClick={handleYesClick}>
            Yes!
          </button>
          <button
            className="no-btn"
            onClick={handleNoClick}
            style={noPosition ? {
              position: 'fixed',
              left: `${noPosition.x}px`,
              top: `${noPosition.y}px`,
            } : {}}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
